<script setup lang="ts">
withDefaults(defineProps<{
  item?: {
    name: string,
    id: number,
    icon: string,
    type: string,
    watermark: string
  },
  large?: boolean,
  small?: boolean
}>(), {
  large: false,
  small: false
})
</script>

<template>
  <div v-if="item" class="absolute border-yellow-400 box-content transition-shadow duration-100 shadow-yellow-400"
    :class="{
      'shadow-[0_0_8px] border-2 h-12 w-12': large && !small,
      'shadow-[0_0_4px] border-2 h-8 w-8': !large && !small,
      'shadow-[0_0_2px] h-4 w-4': !large && small
    }">
    <img class="absolute w-full h-full" :alt="`${item.name} icon`" :src="`/generated/${item.icon}`" />
    <img class="absolute w-full h-full" alt="" :src="`/generated/${item.watermark}`" />
  </div>
</template>